// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__AjlcN {
  width: fit-content;
  cursor: pointer;
  border-radius: 24px;
  border: 1px solid #eeeeee;
  padding: 8px 18px;
  margin: 4px;
  background-color: #fafafa;
  font-size: 14px;
  display: inline-block;
  height: 36px;
}
.styles_container__AjlcN .styles_wrapper__YiJ6R {
  display: flex;
  justify-content: center;
  align-items: stretch;
}
.styles_container__AjlcN .styles_wrapper__YiJ6R .styles_text__pe\\+jc {
  margin: 0;
}

@media only screen and (max-width: 800px) {
  .styles_text__pe\\+jc {
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/Button/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,oBAAA;AACJ;AACI;EACE,SAAA;AACN;;AAcA;EACE;IACE,2BAAA;IACA,0BAAA;IACA,4BAAA;EAXF;AACF","sourcesContent":[".container {\n  width: fit-content;\n  cursor: pointer;\n  border-radius: 24px;\n  border: 1px solid #eeeeee;\n  padding: 8px 18px;\n  margin: 4px;\n  background-color: #fafafa;\n  font-size: 14px;\n  display: inline-block;\n  height: 36px;\n\n  .wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: stretch;\n\n    .text {\n      margin: 0;\n      // padding: 1px;\n      // color: #707070;\n    }\n  }\n}\n\n// .container:active,\n// .container:focus {\n//   background-color: #646464;\n//   .text {\n//     color: #d9d9d9;\n//   }\n// }\n\n@media only screen and (max-width: 800px) {\n  .text {\n    font-weight: 400 !important;\n    font-size: 14px !important;\n    line-height: 20px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__AjlcN`,
	"wrapper": `styles_wrapper__YiJ6R`,
	"text": `styles_text__pe+jc`
};
export default ___CSS_LOADER_EXPORT___;
